export default "__VITE_ASSET__c2467f60__"